import palette from '@lib/core/src/theme/palette';
import { Stack, styled, Typography, Box, IconButton } from '@mui/material';

export const Container = styled(Stack)({
  flexDirection: 'row',
  width: '100%',
  height: '100%',
  position: 'absolute',
  zIndex: 1001
});

export const RightBlur = styled(Box)({
  width: '100%',
  height: '100%',
  background: 'rgba(47, 47, 47, 0.20)',
  backdropFilter: 'blur(7.5px)',
  borderBottomRightRadius: '16px',
  position: 'absolute',
  zIndex: -1
});

export const LeftContent = styled(Stack)({
  width: '100%',
  backgroundColor: palette.white,
  height: '100%'
});
export const Title = styled(Typography)({
  fontSize: '18px',
  fontWeight: '600',
  color: palette.black,
  padding: '0 8px',
  margin: '16px 0'
});

export const ThreadsContainer = styled(Stack)({
  width: '100%',
  height: 'calc(100% - 164px)',
  overflowY: 'auto',
  paddingBottom: '16px',
  paddingLeft: '16px'
});

export const ThreadsContainerTitle = styled(Typography)({
  lineHeight: '51px',
  height: '37px',
  paddingTop: '10px',
  fontWeight: '600',
  fontSize: '11px',
  color: palette.grey[400],
  padding: '0 8px',
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%'
});

export const RowContainer = styled(Stack)({
  position: 'absolute',
  padding: '0',
  top: 0,
  left: 0,
  width: '100%'
});

export const ThreadName = styled(Box, {
  shouldForwardProp: prop => prop !== 'active' && prop !== 'unseen'
})<{ active: boolean; unseen: boolean }>(({ active, unseen }) => ({
  position: 'relative',
  fontSize: '12px',
  color: palette.black,
  height: '40px',
  lineHeight: '40px',
  padding: '0 8px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '100%',
  cursor: 'pointer',
  borderRadius: '8px',
  backgroundColor: active ? 'rgba(47, 47, 47, 0.05)' : 'transparent',
  fontWeight: unseen ? '700' : '500',
  '&:hover': {
    backgroundColor: 'rgba(47, 47, 47, 0.05)',
    paddingRight: '35px'
  },
  '& .three-dots-icon': {
    display: 'none'
  },
  '&:hover .three-dots-icon': {
    display: 'block'
  }
}));

export const EditBoxItem = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
  padding: '0 8px',
  cursor: 'pointer',
  height: '100%',
  '&:hover': {
    backgroundColor: palette.grey[100]
  }
});

export const EditBoxText = styled(Typography)({
  fontSize: '12px',
  color: palette.black
});

export const EmptyThreads = styled(Stack)({
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: '16px',
  backgroundColor: palette.grey[800],
  borderRadius: '8px'
});

export const NoThreadsText = styled(Typography)({
  fontSize: '16px',
  fontWeight: '600',
  color: palette.black,
  margin: '16px 0'
});

export const NoThreadsSubtitle = styled(Typography)({
  fontSize: '14px',
  fontWeight: '400',
  color: palette.grey[400],
  textAlign: 'center',
  padding: '0 8px'
});

export const ThreeDotsIconButton = styled(IconButton)({
  position: 'absolute',
  width: '30px',
  height: '30px',
  paddingTop: '6px',
  right: '3px',
  top: '50%',
  transform: 'translateY(-50%)'
});
